import { NotFoundPage } from "@/components/not-found/NotFoundPage";
import { createRoute } from "@tanstack/react-router";
import { layoutRoute } from "./$layoutRoute";

/**
 * Catch-all for any URL no other route claims, inside the app shell.
 *
 * A splat route rather than relying on `notFoundComponent` alone, because an
 * unmatched URL never reaches `layoutRoute` that way: the router resolves it to
 * the root, skipping `authRoute` too, so a signed-in salon got a shell-less page
 * and a signed-out visitor was never asked to sign in. As a real route under the
 * layout it gets both: the session gate runs first (a signed-out visitor goes to
 * `/login` with the address as `redirect`, like any other protected page), then
 * the shell wraps the page. Every more specific route outranks `$`, so it only
 * ever receives what nothing else matched.
 */
export const notFoundRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: "$",
  component: NotFoundPage
});
